import React from "react";
import Icon from "@ant-design/icons";

export const ArchiveBoxIcon = (props) => {
   return (
      <Icon
         component={() => (
            <svg
               width="15"
               height="16"
               viewBox="0 0 24 24"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
               stroke="currentColor"
            >
               <path
                  d="M2.5714 8.57077H21.4285M2.5714 8.57077V20.5708C2.5714 21.0254 2.75202 21.4615 3.0735 21.7829C3.395 22.1044 3.83103 22.2851 4.28569 22.2851H19.7143C20.1689 22.2851 20.605 22.1044 20.9264 21.7829C21.2479 21.4615 21.4285 21.0254 21.4285 20.5708V8.57077M2.5714 8.57077C1.62463 8.57077 0.857117 7.80325 0.857117 6.85648V3.42791C0.857117 2.48114 1.62463 1.71362 2.5714 1.71362H21.4285C22.3753 1.71362 23.1428 2.48114 23.1428 3.42791V6.85648C23.1428 7.80325 22.3753 8.57077 21.4285 8.57077M9.42855 13.7136H14.5714"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </svg>
         )}
         {...props}
      />
   );
};
